module.exports = __webpack_public_path__ + "9daa986b840a28832e0a8c604a3b7b60.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/ABCMonumentGrotesk-Medium.woff
// module id = 33
// module chunks = 0 1